export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !window.isSecureContext || !('serviceWorker' in navigator)) return;
  const register = () => navigator.serviceWorker.register('/service-worker.js', {scope: '/', updateViaCache: 'none'}).catch(() => {
    // Installation is optional; a registration failure must not interrupt the account.
  });
  if (document.readyState === 'complete') register();
  else window.addEventListener('load', register, {once: true});
}
